var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53366 7.78781L0.193175 1.92106C-0.0643917 1.63811 -0.0643917 1.17938 0.193175 0.896463L0.816057 0.212204C1.07318 -0.0702607 1.48991 -0.0708043 1.74765 0.210996L6.00001 4.8605L10.2524 0.210996C10.5101 -0.0708043 10.9268 -0.0702607 11.1839 0.212204L11.8068 0.896463C12.0644 1.17941 12.0644 1.63814 11.8068 1.92106L6.46637 7.78781C6.2088 8.07073 5.79122 8.07073 5.53366 7.78781Z",
    fill: "#1C83B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaDownArrow);
export default __webpack_public_path__ + "static/media/metaDownArrow.5be50a2ecfbce8876c44c20e817aa8a0.svg";
export { ForwardRef as ReactComponent };